import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../services/auth-service.service';
import { INewUser, IUserProfile } from '../../interfaces/';
import { NewUser, UserProfile } from '../../models/';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

	user: NewUser = new NewUser();
	returnUser: INewUser = new NewUser();
  userProfile: IUserProfile = new UserProfile();

  message: string = "";

  isAuthenticated: boolean = false;
  Loading: boolean= false;

  userNamePWReset: string = "";
  userEmailGetUN: string = "";

  constructor( private authService: AuthServiceService, private router: Router) { }

  ngOnInit() {
    if(sessionStorage.getItem("token")){
      let obj = JSON.parse(sessionStorage.getItem("token"));
      if(obj && obj.Token != ""){
        this.isAuthenticated = true;
        this.router.navigate(['/account']);
      }
    }
  }

  login(){
    this.Loading = true;
    this.userProfile = new UserProfile();
  	this.authService.login(this.user).subscribe(
		resp => {
      if(resp.Id != null && resp.Id != 0){
  			this.returnUser = resp;
        let obj = JSON.parse(sessionStorage.getItem("token"));
        if(obj && obj.Token != ""){
          this.authService.getUserProfile(obj.profileId).subscribe(
            profile => {
              this.userProfile = profile;
            })
          sessionStorage.setItem("referred", 'login');
          this.isAuthenticated = true;
          this.Loading = false;
          location.assign('/#/account');
        }
        else {
          this.isAuthenticated = false;
          this.Loading = false;
          //location.reload();
          this.router.navigate(['/login']);
        }
      }
      else {
        sessionStorage.setItem("token", null);
        this.isAuthenticated = false;
        this.Loading = false;

        this.message = "Invalid login, please check your credentials and try again."
      }
		}

	)}

  RequestPasswordReset(){
    this.authService.PasswordResetRequest(this.userNamePWReset).subscribe(
      resp => {
        let result = resp;
        console.log(resp);
      })
  }

  RequestUsernameByEmail(){
    this.authService.UsernameRequest(this.userEmailGetUN).subscribe(
      resp => {
        let result = resp;
        console.log(resp);
      })
  }


}




// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts